import React from 'react';

export default function FlagThree() {
  return (
    <svg
      width='64'
      height='71'
      viewBox='0 0 64 71'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M57 10L52.1095 3.57688C51.353 2.58326 50.1758 2 48.927 2H14C12.8954 2 12 2.89543 12 4V10H57Z'
        fill='#854831'
      />
      <path
        d='M57 10L52.1095 3.57688C51.353 2.58326 50.1758 2 48.927 2H14C12.8954 2 12 2.89543 12 4V10H57Z'
        fill='black'
        fill-opacity='0.5'
      />
      <g filter='url(#filter0_dd_8281_7152)'>
        <path
          d='M12 4C12 2.89543 12.8954 2 14 2H50C51.1046 2 52 2.89543 52 4V46.7639C52 48.2507 50.4354 49.2177 49.1056 48.5528L32.8944 40.4472C32.3314 40.1657 31.6686 40.1657 31.1056 40.4472L14.8944 48.5528C13.5646 49.2177 12 48.2507 12 46.7639V4Z'
          fill='url(#paint0_linear_8281_7152)'
        />
        <path
          d='M30.8354 32.2784C29.2445 32.2784 27.8757 32.0133 26.7289 31.483C25.5887 30.946 24.7469 30.2102 24.2033 29.2756C23.6597 28.3343 23.4907 27.2472 23.6962 26.0142H28.5783C28.512 26.4583 28.575 26.8527 28.7672 27.1974C28.9661 27.5355 29.2677 27.8007 29.6721 27.9929C30.083 28.1851 30.5603 28.2812 31.1039 28.2812C31.727 28.2812 32.2971 28.1586 32.8141 27.9134C33.3378 27.6681 33.7686 27.34 34.1067 26.929C34.4448 26.518 34.6536 26.0672 34.7331 25.5767C34.8127 25.0994 34.7398 24.6984 34.5144 24.3736C34.289 24.0488 33.9443 23.8035 33.4803 23.6378C33.0229 23.4721 32.4628 23.3892 31.7999 23.3892H29.7218L30.2985 19.8892H32.1678C32.7776 19.8892 33.3378 19.7765 33.8482 19.5511C34.3652 19.3258 34.7928 19.0142 35.1309 18.6165C35.4689 18.2187 35.681 17.7614 35.7672 17.2443C35.8335 16.8333 35.8004 16.4754 35.6678 16.1705C35.5352 15.8589 35.3032 15.6203 34.9718 15.4545C34.647 15.2822 34.2227 15.196 33.699 15.196C33.1422 15.196 32.6053 15.2921 32.0882 15.4844C31.5778 15.6766 31.147 15.9484 30.7956 16.2997C30.4443 16.651 30.2322 17.0587 30.1593 17.5227H25.486C25.6915 16.3163 26.1953 15.2524 26.9973 14.331C27.7994 13.4029 28.8004 12.6771 30.0002 12.1534C31.2066 11.6231 32.5191 11.358 33.9377 11.358C35.4358 11.358 36.7019 11.6397 37.736 12.2031C38.7767 12.7599 39.5357 13.5024 40.013 14.4304C40.4969 15.3518 40.646 16.3561 40.4604 17.4432C40.2682 18.6297 39.7445 19.5478 38.8894 20.1974C38.0343 20.8404 36.9703 21.2415 35.6976 21.4006V21.5497C37.1029 21.7221 38.1768 22.2623 38.9192 23.1705C39.6683 24.072 39.9367 25.1723 39.7246 26.4716C39.5456 27.5919 39.0452 28.5895 38.2232 29.4645C37.4012 30.3395 36.3506 31.0289 35.0712 31.5327C33.7985 32.0298 32.3865 32.2784 30.8354 32.2784Z'
          fill='url(#paint1_linear_8281_7152)'
        />
      </g>
      <defs>
        <filter
          id='filter0_dd_8281_7152'
          x='0'
          y='0'
          width='64'
          height='72'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='3'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_8281_7152'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='7.5' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8281_7152'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='4'
            operator='erode'
            in='SourceAlpha'
            result='effect2_dropShadow_8281_7152'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='3' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_8281_7152'
            result='effect2_dropShadow_8281_7152'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_8281_7152'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_8281_7152'
          x1='32'
          y1='2'
          x2='32'
          y2='50'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#854831' />
          <stop offset='1' stop-color='#612F1C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_8281_7152'
          x1='32'
          y1='2'
          x2='32'
          y2='42'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#151518' />
          <stop offset='1' stop-color='#612F1C' />
        </linearGradient>
      </defs>
    </svg>
  );
}
